module.exports = __webpack_public_path__ + "img/arrow_right_simple.f360a016.svg";